<template>
  <div class="autobid">
    <h2>{{$t('nav.w25')}}</h2>
    <div class="nav">
      <span :class="{'navactive': type==0}" @click="type=0">{{$t('nav.w53')}}</span>
      <span :class="{'navactive': type==1}" @click="type=1">{{$t('nav.w54')}}</span>
    </div>
    <div class="link">
      <router-link :to="{name:'createbid'}">{{$t('nav.w55')}}</router-link>
      <router-link :to="{name:'setbid'}" class="a1">{{$t('nav.w27')}}</router-link>
    </div>
    <div class="effective-list">
      <Datatable
        url="/Member/RZJLoan/AutomaticList"
        :th="[$t('label.w3'),$t('label.w147'),$t('label.w148')+'/'+$t('label.w149'),$t('label.w54'),$t('label.w150'),type?$t('label.w151'):$t('label.w152'),$t('label.w19')]"
        field="AutomaticList"
        :filter="dataFilter"
        ref="Datatable"
        :tip="$t('msg.m111')"
      >
        <template v-slot="{item}">
          <tr>
            <td class="relative">
              <span class="typetab t2" v-if="item.CreateMode==0">{{$t('option.w50')}}</span>
              <span class="typetab t1" v-if="item.CreateMode==1">{{$t('option.w51')}}</span>
              <span class="rate">{{item.Rate.toFixed(1)}}%</span>
            </td>
            <td>
              <span v-if="type==0">{{item.TotalAmount-item.InvestingAmount | money}}</span>
              <span v-else>--</span>
            </td>
            <td>
              <div>￥{{item.InvestingAmount | money}}</div>
              <div>￥{{item.TotalAmount | money}}</div>
            </td>
            <td>
              <div>{{item.CycleDay}}</div>
              <div>{{item.CycleMonth}}</div>
            </td>
            <td>
              {{item.DomainTypeCount}}
              <span class="detailIcon" v-if="item.DomainTypeCount">
                <Icon type="ios-alert-outline" size="16"/>
                <div class="text">
                  <Row :gutter="10" v-for="(v,n) in item.DomainTypeList" :key="n" :style="{marginBottom:'10px'}">
                    <Col span="4">
                      <div><b>{{n}}</b></div>
                    </Col>
                    <Col span="20">
                      <div class="dntype"><span v-for="(vv,ii) in v" :key="ii">{{vv}}</span></div>
                    </Col>
                  </Row>
                </div>
              </span>
            </td>
            <td>{{type?item.CancelAt:item.CreatedAt}}</td>
            <td>
              <span class="opebtn" v-if="type==0">
                <a href="javascript:;" @click="cancel(item)">{{$t('btn.b39')}}</a>
              </span>
              <span class="opebtn">
                <a href="javascript:;" @click="detail(item)">{{detailId===item.Id?$t('btn.b69'):$t('btn.b70')}}</a>
              </span>
            </td>
          </tr>
          <tr v-if="detailId===item.Id">
            <td colspan="7" class="detailtd">
              <div :style="{position:'relative',minHeight:'74px'}">
                <Spin fix v-show="detailloading"></Spin>
                <table>
                  <tr>
                    <th>{{$t('label.w153')}}</th>
                    <th>{{$t('label.w1')}}</th>
                    <th>{{$t('label.w154')}}</th>
                    <th>{{$t('label.w17')}}</th>
                    <th>{{$t('label.w53')}}</th>
                  </tr>
                  <tr v-for="v in detailList" :key="v.Id">
                    <td>{{v.Number}}</td>
                    <td>￥{{v.Amount | money}}</td>
                    <td>{{v.CreatedAt}}</td>
                    <td>{{v.LoanCycleValue<30?v.LoanCycleValue+$t('label.w15'):(v.LoanCycleValue/30)+$t('label.w14')}}</td>
                    <td>{{v.StateName}}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </Datatable>
    </div>
    <Cancel ref="Cancel" @done="refresh"/>
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import Cancel from "./modal/cancel";
export default {
  components: { Datatable ,Cancel},
  data() {
    return {
      dataFilter:{
        invalid:0
      },
      detailloading:false,
      detailList:[],
      detailId:'',
      type:0
    }
  },
  methods:{
    filterChange(t) {
      let v = {};
      v.pledgeName = this.pledgeName;
      if (t == "s1" && this.s1) {
        this.s2 = 0;
        v.pledgeStateQuery = this.s1;
      } else if (t == "s2" && this.s2) {
        this.s1 = 0;
        v.pledgeStateQuery = this.s2;
      }
      this.dataFilter = v;
    },
    detail(v) {
      if (this.detailloading) return;
      if (this.detailId == v.Id) return (this.detailId = "");
      this.detailId = v.Id;
      this.detailloading = true;
      this.detailList = [];
      this.$axios
        .get("/Member/RZJLoan/AutomaticInvestmentScheme?automaticId=" + v.Id)
        .then(res => {
          this.detailloading = false;
          if (!res.err) {
            this.detailList = res;
          }
        });
    },
    cancel(v){
      this.$refs.Cancel.id=v.Id
    },
    refresh(){
      this.$refs.Datatable.refresh()
    }
  },
  watch:{
    type(v){
      this.dataFilter={
        invalid:v
      }
    }
  }
};
</script>

<style lang="less" scoped>
td.relative{
  height: 80px;
}
.autobid {
  .nav {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #d7d7d9;
    span {
      display: inline-block;
      font-size: 18px;
      cursor: pointer;
      color: #232325;
      padding: 30px 0;
      margin: 0 32px;
    }
    .navactive {
      color: #6a98ff;
      font-weight: 500;
      position: relative;
      &::before {
        position: absolute;
        left: 0;
        bottom: -1px;
        height: 4px;
        background: #6a98ff;
        width: 100%;
        display: block;
        content: "";
      }
    }
  }
  .link {
    display: flex;
    justify-content: flex-end;
    margin: 30px 0px;
    a {
      display: inline-block;
      width: 130px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      color: #979797;
      border-radius: 8px;
      border: 1px solid rgba(151, 151, 151, 1);
      text-align: center;
    }
    .a1{
        margin-left: 20px;
        color: #fff;
        background: #6a98ff;
        border: 0;
    }
  }
}
.dntype{
  text-align: left;
  span{
    display: inline-block;
    padding: 0 5px;
    height:20px;
    line-height: 18px;
    border-radius:2px;
    font-size: 12px;
    color: #999;
    border:1px solid #999;
    margin-right: 6px;
    margin-bottom: 6px;
  }
}
.rate{
  color:#FF6106;
  font-size: 18px;
}
.typetab{
  padding-left:10px;
  padding-right: 20px;
  height:22px;
  border-radius:0px 0px 100px 0px;
  position: absolute;
  left: 0;
  top: -1px;
  font-size: 12px;
  line-height: 21px;
  color: #fff;
  &.t1{
    background:linear-gradient(270deg,rgba(93,241,224,1) 0%,rgba(80,189,226,1) 100%);
  }
  &.t2{
    background:linear-gradient(270deg,rgba(170,158,253,1) 0%,rgba(117,135,245,1) 100%);
  }
}
.detailIcon{
  position: relative;
  .text {
    display: none;
    width: 460px;
    padding: 15px 15px 5px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    background: #fff;
    font-style: normal;
    font-size: 14px;
    color: #000000;
    position: absolute;
    left: -19px;
    bottom: 20px;
    z-index: 5;
    &:before {
      display: block;
      content: "";
      position: absolute;
      left: 18px;
      bottom: -6px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid rgba(255, 255, 255, 1);
      z-index: 5;
    }
  }
  &:hover{
    .text{
      display: block;
    }
  }
}
.detailtd {
  padding: 0 !important;
  background: rgba(233, 234, 238, 1);
  line-height: 20px;
  box-shadow: inset 0px 30px 15px -20px rgba(0, 0, 0, 0.1);
  tbody {
    background: none !important;
  }
  tr {
    border-color: #dbdce0;
    &:last-child {
      border-bottom: 0;
    }
  }
  td,
  th {
    padding: 8px;
    height: auto;
    &:first-child {
      text-align: left;
      padding-left: 30px;
    }
  }
  th {
    font-size: 12px;
    color: #7b7b7c;
    font-weight: normal;
  }
}
.opebtn {
  &:before {
    content: "|";
    margin: 0 8px;
    color: #ccc;
  }
  &:first-child {
    &:before {
      display: none;
    }
  }
}
</style>

